/**
 * AW List Products — Embla init
 */

function initListProducts(root = document) {
  root.querySelectorAll('[data-aw-list-products]').forEach((el) => {
    if (el.dataset.awListProductsInit) return;
    el.dataset.awListProductsInit = '1';

    initEmbla(el, {
      loop: false,
      align: 'start',
    });
  });
}

document.addEventListener('DOMContentLoaded', () => initListProducts());
document.addEventListener('shopify:section:load', (e) => initListProducts(e.target));